import { render, staticRenderFns } from "./ReceiptDialog.vue?vue&type=template&id=2b47b58d&scoped=true"
import script from "./ReceiptDialog.vue?vue&type=script&lang=js"
export * from "./ReceiptDialog.vue?vue&type=script&lang=js"
import style0 from "./ReceiptDialog.vue?vue&type=style&index=0&id=2b47b58d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b47b58d",
  null
  
)

export default component.exports